import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
  computed,
} from '@angular/core';

export type AlertVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'info'
  | 'warning';

@Component({
  selector: 'ps-alert',
  standalone: true,
  templateUrl: './alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  public readonly dismissible = input<boolean>(true);
  public readonly variant = input<AlertVariant>('primary');
  public readonly dismissed = output<void>();

  protected readonly visible = signal<boolean>(true);

  protected readonly variantClass = computed(() => {
    return [`alert-${this.variant()}`];
  });

  protected close(): void {
    this.visible.set(false);
    this.dismissed.emit();
  }
}
